import { useFormikContext } from "formik"

interface ImageOption {
  id: number | string
  image_url: string | undefined
  thumbnail?: string | undefined
  title?: string
  alt?: string
}

interface ImageSelectFieldProps {
  name: string
  label?: string
  options: ImageOption[]
  imageWidth?: number
  imageHeight?: number
  gap?: number
  showTitle?: boolean
  emptyMessage?: string
  className?: string
}

export function ImageSelectField({
  name,
  label,
  options,
  imageWidth = 100,
  imageHeight = 100,
  gap = 3,
  showTitle = true,
  emptyMessage = "No images available",
  className = "",
}: ImageSelectFieldProps) {
  const { setFieldValue, values, errors, touched } = useFormikContext<any>()
  
  const selectedValue = values[name]
  const error = touched[name] && errors[name]

  return (
    <div className={`d-flex flex-column ${className}`} style={{ maxHeight: '200px', overflowY: 'auto' }}>
      {label && <label className="form-label">{label}</label>}
      
      <div className={`d-flex align-items-center flex-wrap gap-${gap}`}>
        {options && options.length > 0 ? (
          options.map((option) => {
            const isSelected = selectedValue === option.id
            
            return (
              <div
                key={option.id}
                className="d-flex flex-column align-items-center"
                style={{ cursor: "pointer" }}
                onClick={() => setFieldValue(name, option.id)}
              >

                <img
                  src={option.thumbnail || option.image_url}
                  alt={option.alt || option.title || `Image ${option.id}`}
                  style={{
                    width: `${imageWidth}px`,
                    height: `${imageHeight}px`,
                    objectFit: "contain",
                    border: isSelected ? "3px solid #007bff" : "1px solid #ccc",
                    borderRadius: "4px",
                    transition: "border 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    if (!isSelected) {
                      e.currentTarget.style.border = "2px solid #007bff"
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!isSelected) {
                      e.currentTarget.style.border = "1px solid #ccc"
                    }
                  }}
                />
                {showTitle && 
                  <span className="mt-1" style={{ fontSize: "0.475rem", textAlign: "center" }}>{
                    option.image_url?.split("/").pop()?.split(".")[0].slice(0, 15) || "Untitled"
                  }</span>

                }
              </div>
            )
          })
        ) : (
          <span className="text-muted">{emptyMessage}</span>
        )}
      </div>
      
      {error && (
        <div className="invalid-feedback d-block mt-1">
          {typeof error === "string" ? error : "Invalid selection"}
        </div>
      )}
    </div>
  )
}